"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["className", "reserveHintSpace"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { c as _c } from "react/compiler-runtime";
import { LoadingBox, Stack, useBoxStyles } from '@autoguru/overdrive';
import { HintText } from '@autoguru/overdrive/dist/components/private/InputBase/HintText';
import clsx from 'clsx';
import * as styles from './InputLoading.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const InputLoading = t0 => {
  const $ = _c(24);
  let className;
  let loadingBoxProps;
  let reserveHintSpace;
  if ($[0] !== t0) {
    var _t = t0;
    ({
      className,
      reserveHintSpace
    } = _t);
    loadingBoxProps = _objectWithoutProperties(_t, _excluded);
    _t;
    $[0] = t0;
    $[1] = className;
    $[2] = loadingBoxProps;
    $[3] = reserveHintSpace;
  } else {
    className = $[1];
    loadingBoxProps = $[2];
    reserveHintSpace = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "full"
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = useBoxStyles(t1);
  let t3;
  if ($[5] !== className || $[6] !== t2) {
    t3 = clsx(className, styles.inputLoading, t2);
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== loadingBoxProps || $[9] !== t3) {
    t4 = /*#__PURE__*/_jsx(LoadingBox, _objectSpread(_objectSpread({}, loadingBoxProps), {}, {
      className: t3
    }));
    $[8] = loadingBoxProps;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      width: "full"
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = useBoxStyles(t5);
  let t7;
  if ($[12] !== className || $[13] !== t6) {
    t7 = clsx(className, styles.inputLoading, t6);
    $[12] = className;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== loadingBoxProps || $[16] !== t7) {
    t8 = /*#__PURE__*/_jsx(LoadingBox, _objectSpread(_objectSpread({}, loadingBoxProps), {}, {
      className: t7
    }));
    $[15] = loadingBoxProps;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== reserveHintSpace) {
    t9 = reserveHintSpace ? /*#__PURE__*/_jsx(HintText, {
      reserveHintSpace: reserveHintSpace,
      hintText: void 0
    }) : null;
    $[18] = reserveHintSpace;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t4 || $[21] !== t8 || $[22] !== t9) {
    t10 = /*#__PURE__*/_jsxs(Stack, {
      width: "full",
      space: "none",
      children: [t4, t8, t9]
    });
    $[20] = t4;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};